export const toSuggestion = item =>
  !!item
    ? {
        ...item,
        id: item.id,
        label: item.description,
        value: item.id,
      }
    : undefined;



// WEBPACK FOOTER //
// ./src/lib/dataLayer/diagnoses/util.js